<div class="container">
  <div
    class="offset-sm-1 col-sm-10 pt-5 webview text-center"
    [@flyInOut]="'in'"
  >
    <h1 class="text-center font-weight-normal-calibre questxt">
      {{ question_sub1 }}
    </h1>
    <h1 class="text-center font-weight-normal-calibre pb-2 questxt">
      {{ question_sub2 }}
    </h1>
    <p class="m-0 mb-3 text-muted tapmsg">Select all that apply</p>
    <div class="row col-12 px-0">
      <div class="col-sm-6 col-md-6 text-left">
        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="investment1"
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="investment1"
            value="hgInvestments.investment1"
            name="hg_investment"
            [(ngModel)]="hgInvestments.investment1"
            (ngModelChange)="
              getHg_investment(
                'LEDs, lighting controls or sensors',
                hgInvestments.investment1
              )
            "
          />
          <label class="custom-control-label font20" for="investment1"
            >LEDs, lighting controls or sensors</label
          >
        </label>

        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="investment4"
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="investment4"
            value="hgInvestments.investment4"
            name="hg_investment"
            [(ngModel)]="hgInvestments.investment4"
            (ngModelChange)="
              getHg_investment('Building automation', hgInvestments.investment4)
            "
          />
          <label class="custom-control-label font20" for="investment4"
            >Building automation</label
          >
        </label>

        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="investment5"
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="investment5"
            value="hgInvestments.investment5"
            name="hg_investment"
            [(ngModel)]="hgInvestments.investment5"
            (ngModelChange)="
              getHg_investment('Window technology', hgInvestments.investment5)
            "
          />
          <label class="custom-control-label font20" for="investment5"
            >Window technology</label
          >
        </label>
      </div>
      <div class="col-sm-6 col-md-6 text-left">
        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="investment2"
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="investment2"
            value="hgInvestments.investment2"
            name="hg_investment"
            [(ngModel)]="hgInvestments.investment2"
            (ngModelChange)="
              getHg_investment(
                'HVAC & refrigeration controls',
                hgInvestments.investment2
              )
            "
          />
          <label class="custom-control-label font20" for="investment2"
            >HVAC & refrigeration controls</label
          >
        </label>
        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="investment3"
        >
          <input
            type="checkbox"
            class="custom-control-input mgntp10"
            id="investment3"
            value="hgInvestments.investment3"
            name="hg_investment"
            [(ngModel)]="hgInvestments.investment3"
            (ngModelChange)="
              getHg_investment('Demand management', hgInvestments.investment3)
            "
          />
          <label class="custom-control-label font20" for="investment3"
            >Demand management</label
          >
        </label>
        <label
          class="custom-control custom-checkbox chkbox mb-2"
          for="investment6"
        >
          <div class="nowrap">
            <input
              type="checkbox"
              class="custom-control-input mgntp10"
              id="investment6"
              value="hgInvestments.investment6"
              name="hg_investment"
              [(ngModel)]="hgInvestments.investment6"
              (ngModelChange)="
                getHg_investment('Other', hgInvestments.investment6)
              "
              (click)="myInputFocus()"
            />
            <label class="custom-control-label font20" for="investment6"
              >Other</label
            >
            <input
              #myInput
              type="text"
              #Oth
              maxlength="32"
              class="custom-control-label other-input"
              [(ngModel)]="other"
              (ngModelChange)="getOther()"
            />
          </div>
        </label>
      </div>
    </div>
    <button
      class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase"
      [disabled]="isDisable"
      [ngClass]="{ combtn: user_bot }"
      (click)="next()"
    >
      Next
    </button>
    <div class="mt-5" *ngIf="showTip">
      <div
        class="m-auto col-sm-12 col-md-6 col-xl-6 blockbg boxclr text-center"
      >
        <img src="assets/images/flash.png" class="mb-1" />
        <p class="text-center tiphead">IF INTERESTED</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
      </div>
    </div>
  </div>
</div>
<div
  class="container mobileview mt-4 mb-4 px-0"
  [attr.id]="questionObj._id"
  style="float: left"
>
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <p class="m-auto py-3 text-muted tapmsg">Tap all that apply</p>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="investment1_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="investment1_mob"
        value="hgInvestments.investment1"
        name="hg_investment"
        [(ngModel)]="hgInvestments.investment1"
        (ngModelChange)="
          getHg_investment(
            'LEDs, lighting controls or sensors',
            hgInvestments.investment1
          )
        "
      />
      <label class="custom-control-label font20" for="investment1_mob"
        >LEDs, lighting controls or sensors</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="investment2_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="investment2_mob"
        value="hgInvestments.investment2"
        name="hg_investment"
        [(ngModel)]="hgInvestments.investment2"
        (ngModelChange)="
          getHg_investment(
            'HVAC & refrigeration controls',
            hgInvestments.investment2
          )
        "
      />
      <label class="custom-control-label font20" for="investment2_mob"
        >HVAC & refrigeration controls</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="investment4_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="investment4_mob"
        value="hgInvestments.investment4"
        name="hg_investment"
        [(ngModel)]="hgInvestments.investment4"
        (ngModelChange)="
          getHg_investment('Building automation', hgInvestments.investment4)
        "
      />
      <label class="custom-control-label font20" for="investment4_mob"
        >Building automation
      </label>
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="investment3_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="investment3_mob"
        value="hgInvestments.investment3"
        name="hg_investment"
        [(ngModel)]="hgInvestments.investment3"
        (ngModelChange)="
          getHg_investment('Demand management', hgInvestments.investment3)
        "
      />
      <label class="custom-control-label font20" for="investment3_mob"
        >Demand management</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="investment5_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="investment5_mob"
        value="hgInvestments.investment5"
        name="hg_investment"
        [(ngModel)]="hgInvestments.investment5"
        (ngModelChange)="
          getHg_investment('Window technology', hgInvestments.investment5)
        "
      />
      <label class="custom-control-label font20" for="investment5_mob"
        >Window technology</label
      >
    </label>
    <label
      class="custom-control custom-checkbox chkbox mb-2"
      for="investment6_mob"
    >
      <input
        type="checkbox"
        class="custom-control-input mgntp10"
        id="investment6_mob"
        value="hgInvestments.investment6"
        name="hg_investment"
        [(ngModel)]="hgInvestments.investment6"
        (ngModelChange)="getHg_investment('Other', hgInvestments.investment6)"
        (click)="myInputFocus()"
      />
      <label class="custom-control-label font20" for="investment6_mob"
        >Other</label
      >
      <input
        #myInput
        type="text"
        #Oth_mob
        maxlength="32"
        class="custom-control-label other-input"
        [(ngModel)]="other"
        (keyup.enter)="getOther()"
      />
    </label>
    <br />
  </div>
  <div class="col-12" *ngIf="showTip">
    <div class="blockbg boxclr p-2">
      <img
        src="assets/images/flash.png"
        class="mb-1"
        style="margin-left: 48%"
      />
      <p class="text-center tiphead">IF INTERESTED</p>
      <p class="text-center tipmes">{{ questionObj.tip }}</p>
    </div>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
      <div class="arrow_box">
        <img
          class="p-2 pl-2 ml-1"
          src="assets/images/typing-animated-gif-4.gif"
        />
      </div>
    </div>
  </div>
</div>
